import React from 'react';
import { ModalContainer, ModalHeader, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks';
import { LogoIcon } from '@cp/ds/src/icons';
import { useTrackMount } from 'src/shared/tracking';
import { LoginModalOpened } from '../lib';
import { DEFAULT_LOGIN_STRATEGY } from '../model';
import { LoginForm } from './loginForm';
import { LoginModalProps } from './loginModalLayout.types';
import { AuthAgreement } from './agreement';

export * from './loginModalLayout.types';

export const LoginModalLayout: React.FC<LoginModalProps> = ({
  title = 'Вход или регистрация',
  onClose,
  onSuccess,
  desc,
  loginStrategy = DEFAULT_LOGIN_STRATEGY,
  ...props
}) => {
  useTrackMount(LoginModalOpened);
  const theme = useTheme();
  return (
    <ModalLayout
      icon={<LogoIcon fontSize="3rem" sx={{ color: theme.palette['brand pink'] }} />}
      onBack={onClose}
      onClose={onClose}
      {...props}
    >
      <ModalContainer sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: '30px' }}>
        <ModalHeader>{title}</ModalHeader>
        {desc && (
          <Typography component="div" sx={{ textAlign: 'center' }} variant="body bold">
            {desc}
          </Typography>
        )}
        <LoginForm loginStrategy={loginStrategy} onSuccess={onSuccess} />
      </ModalContainer>
    </ModalLayout>
  );
};
